import clsx, { type ClassValue } from "clsx";

export const cn = (...classes: ClassValue[]) => clsx(classes);

export const newId = () => crypto.randomUUID();
